import Vue from 'vue'
import ImgFrame from './ImgFrame.vue'

const ImgFrameConstructor = Vue.extend(ImgFrame)
const instance = new ImgFrameConstructor({
  el: document.createElement('div')
})

instance.vm = instance.$mount()
document.body.appendChild(instance.vm.$el)

export default instance



// WEBPACK FOOTER //
// ./src/components/ImgFrame/index.js